import { getCoords, hideElement } from '../../utils/dom-utils';
import { isGalleryPage, isHomePage, isSportDataPage, isSportDomain } from '../../utils/aem-utils';
import { commonStore } from '../../global-store/subjects/common';
import { VIDEO_PLAYER_OBSERVER_OPTIONS, VIDEO_PLAYER_POSITIONS } from '../video-player/constants';
import { initVideoCarouselListeners } from '../video-player/helpers';

import {
  ABSTRACT_CLASSNAME,
  ASPECT_RATIO_CLASS_NAME,
  PLAYER_WITH_CAROUSEL_ID,
  GLOBAL_NAV_HOOK,
  CAROUSEL_HOOK,
  UTILITY_VIDEO_STICKY_CLASS_NAME,
  TOLERANCE_SPACE,
  $videoCarouselSticky,
  $videoCarouselStickyHeader,
  $localNav,
  $videoCarouselStickyContainer,
  $videoElemenCarouseltStickyContainerSpace,
  stickyDeviceMode,
  stickyCarouselActive,
  HERO_CLASSNAME,
} from './constants';
import {
  destroyStickyCarousel,
  hasScrolledOut,
  settingLandscape,
  setVideoCarouselPosition,
  shouldInitCarousel,
  shouldSticky,
  toggleStickyHeaderX,
} from './helpers';
import { stickyCarouselState } from './state';

/**
 * Create header and x for close element
 */

export const stickyCarousel = (player) => {
  if (shouldInitCarousel(stickyCarouselActive, stickyDeviceMode)) {
    stickyCarouselState.setState('playertype', $videoCarouselSticky?.querySelector(CAROUSEL_HOOK)?.dataset?.playertype);
    stickyCarouselState.setState(
      'autoStart',
      $videoCarouselSticky?.querySelector(PLAYER_WITH_CAROUSEL_ID)?.dataset?.autostart === 'true'
    );
    const videoPlayer = player;
    // call back of the observer, check if the element is in view or not in order to manage its status
    const observerCarouselCallBack = (entries) => {
      const videoCarouselStatus = commonStore.getValue().videoCarouselStatus;
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0.6) {
          $videoElemenCarouseltStickyContainerSpace.classList.remove(ASPECT_RATIO_CLASS_NAME);
          setVideoCarouselPosition($videoCarouselSticky, videoPlayer, VIDEO_PLAYER_POSITIONS.DEFAULT);
          hideElement($videoCarouselStickyHeader);
        } else {
          let bottomFlag;
          const scrollingPage = window.innerHeight + window.scrollY;
          const pageBodyHeight = document.body.offsetHeight;
          const difference = pageBodyHeight - scrollingPage;
          if (difference <= TOLERANCE_SPACE) {
            bottomFlag = true;
          }
          if (
            shouldSticky($videoCarouselStickyContainer) &&
            stickyCarouselState.getState('autoStart') &&
            !stickyCarouselState.getState('isClosed') &&
            !bottomFlag
          ) {
            if (isHomePage() && isSportDomain()) {
              const heroScroll = getCoords(document.querySelector(HERO_CLASSNAME)).bottom;
              if (!hasScrolledOut(heroScroll)) {
                return;
              }
            }
            setVideoCarouselPosition($videoCarouselSticky, videoPlayer, VIDEO_PLAYER_POSITIONS.STICKY);
            $videoElemenCarouseltStickyContainerSpace.classList.add(ASPECT_RATIO_CLASS_NAME);
            toggleStickyHeaderX(videoPlayer);
          }
        }
        videoPlayer.resize();
      });
    };

    const observerCarouselSticky = new IntersectionObserver(observerCarouselCallBack, VIDEO_PLAYER_OBSERVER_OPTIONS);

    // the logic run only after first scroll
    const runStickyValue = () => {
      if (stickyCarouselState.getState('isScrolled')) {
        return;
      }
      stickyCarouselState.setState('isScrolled', true);
      console.info('[ STICKY - CAROUSEL ] Run sticky Carousel');
      observerCarouselSticky.observe($videoCarouselStickyContainer);
    };

    const scrollCallback = () => {
      if (isSportDataPage()) {
        const globalNavScroll = getCoords(document.querySelector(GLOBAL_NAV_HOOK)).top;
        if (hasScrolledOut(globalNavScroll)) {
          runStickyValue();
        }
      } else if (isGalleryPage()) {
        const abstractScroll = getCoords(document.querySelector(ABSTRACT_CLASSNAME)).top;
        if (hasScrolledOut(abstractScroll)) {
          runStickyValue();
        }
      } else if (isHomePage() && isSportDomain()) {
        const heroScroll = getCoords(document.querySelector(HERO_CLASSNAME)).bottom;
        if (hasScrolledOut(heroScroll)) {
          runStickyValue();
        }
      } else if (!isGalleryPage()) {
        runStickyValue();
      }
    };

    // the logic run only after first scroll launch callback
    window.addEventListener('scroll', scrollCallback);

    // check status of the player
    initVideoCarouselListeners(videoPlayer);

    // create sticky Header with title and x for close
    $videoCarouselStickyHeader.addEventListener('click', () => {
      videoPlayer.pause();
      $videoElemenCarouseltStickyContainerSpace.classList.remove(ASPECT_RATIO_CLASS_NAME);
      hideElement($videoCarouselStickyHeader);
      destroyStickyCarousel(observerCarouselSticky, $videoCarouselStickyContainer, $videoCarouselSticky, videoPlayer);
      videoPlayer.resize();
    });

    $localNav.addEventListener('click', () => {
      if ($videoCarouselStickyHeader.classList.contains(UTILITY_VIDEO_STICKY_CLASS_NAME)) {
        $videoCarouselSticky.classList.remove(UTILITY_VIDEO_STICKY_CLASS_NAME);
      } else {
        $videoCarouselSticky.classList.add(UTILITY_VIDEO_STICKY_CLASS_NAME);
      }
      videoPlayer.pause();
    });

    // Logic for settings display of sticky element.
    settingLandscape(player, observerCarouselSticky);
  }
};
